/**
 * @generated SignedSource<<19fc137a8130a6dd568a83ad1da97a74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type seriesWidgetDisplayArticle$data = {
  readonly entityId: string;
  readonly seriesContainer: {
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetEntrypointHeadlineArticle">;
  readonly " $fragmentType": "seriesWidgetDisplayArticle";
};
export type seriesWidgetDisplayArticle$key = {
  readonly " $data"?: seriesWidgetDisplayArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"seriesWidgetDisplayArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "seriesWidgetDisplayArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "seriesWidgetEntrypointHeadlineArticle"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "9996de660fd84b20b370894156730ae4";

export default node;
